import { IonText } from '@ionic/react'
import moment from 'moment-timezone'
import { useContext } from 'react'
import styled from 'styled-components'
import { CustomSpacer, PagingContent, TextStyle } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react'
import { ProductInfo } from '../components'

export const MainTradeStatusYet: React.FC = observer(() => {
  const { marketStore } = useContext(StoresContext)
  const pagingStore = marketStore.tradeStatusYetPagingStore

  return (
    <PagingContent pagingStore={pagingStore}>
      {pagingStore.list.map((d, i) => (
        <ProductInfoContainer key={i}>
          <DateContainer>
            <IonText className="date">{`${moment(new Date(d.createdDate)).format('YY.MM.DD')}`}</IonText>
          </DateContainer>
          <SectionContainer>
            <div>
              <ProductInfo
                orderSequence={d.orderSequence}
                title={d.product.name}
                createdDate={d.createdDate}
                img={d.product.imageUri}
                orderType={d.type}
                status={'YET'}
              />
              <CustomSpacer spacing="16px" />
              <ContentWrap>
                <div>
                  {d.type === 'SELL' && (
                    <TextStyle type={'r_14'} color={'secondary_main'}>
                      트레이드(매수)
                    </TextStyle>
                  )}
                  {d.type === 'BUY' && (
                    <TextStyle type={'r_14'} color={'error_main'}>
                      트레이드(매수)
                    </TextStyle>
                  )}
                </div>
                <TextStyle type={'r_14'}>주문 {Math.abs(d.count ?? 0).toLocaleString()} 개</TextStyle>
              </ContentWrap>
              <ContentWrap>
                <div>
                  <IonText className="title">단가</IonText>&nbsp;
                  <IonText>{(d.cost ?? 0).toLocaleString()} 원</IonText>
                </div>
                <IonText>체결 {Math.floor(Math.abs(d.count - d.remainCount ?? 0))} 개</IonText>
              </ContentWrap>
            </div>
            <CustomSpacer spacing="16px" bottomLine={true} />
            <CustomSpacer spacing="16px" />
          </SectionContainer>
        </ProductInfoContainer>
      ))}
    </PagingContent>
  )
})

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  :hover {
    background-color: var(--ion-color-gray100);
  }
`

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  .section-title {
    font-size: 16px;
    font-weight: 700;
  }
  .order-sequence {
    margin-left: 4px;
    font-size: 11px;
    font-weight: 400;
    color: #888888;
  }
`

const ContentWrap = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 400;
  .bold {
    font-weight: bold;
  }
  div {
    display: flex;
    justify-content: space-between;
  }
`

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  .date {
    font-size: 12px;
    font-weight: 700;
  }
  .time {
    font-size: 11px;
    font-weight: 400;
    color: #888888;
  }
`
